<template>
  <div class="aside-box">
    <div class="floor-name">
      <div class="info-name">
        <span style="opacity: 0">*</span>
        <p>楼层名称</p>
      </div>
      <div class="info-content">
        <el-input
          v-model.trim="info.name"
          placeholder="请输入楼层名称"
          maxlength="4"
          show-word-limit
          class="floor-name-input"
          @input="updateVuex()"
        >
          <div slot="prefix" class="name-icon-box">
            <img
              src="../../../assets/images/pc-decoration/discount-name-icon.png"
              alt=""
              class="discount-name-icon"
            />
          </div>
        </el-input>
      </div>
    </div>
    <div class="info-name">
      <span style="opacity: 0">*</span>
      <p>限时折扣内容</p>
      <div class="name-tip">折扣结束后内容不再展示</div>
    </div>

    <div class="floor-body">
      <div class="info-content">
        <div class="info-content-item">
          <p class="item-name"><span>*</span>内容来源</p>
          <div class="item-content">
            <el-select
              v-model="info.style"
              clearable
              class="type-select"
              placeholder="请选择"
              @change="changeHandler"
            >
              <el-option
                v-for="(item2, index2) in options"
                :key="index2"
                :label="item2.label"
                :value="item2.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="zdy-content" v-show="info.contentOrigin == 2">
          <ul class="content-list" id="content-list">
            <li
              class="content-li"
              v-for="(item3, index) in info.contentList"
              :key="index"
            >
              <p>
                {{ item3.title }}
              </p>
              <div
                class="del-content-icon"
                @click="delSelectContent(index)"
              ></div>
            </li>
          </ul>
          <div class="add-content-li" @click="addDIYContent()">
            <span>+</span>
            <p>添加内容</p>
            <div>
              （{{ info.contentList ? info.contentList.length : 0 }}/{{
                info.maxCount
              }}）
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sortable from "sortablejs";
export default {
  name: "ShopCenterAdminWebMAsideDiscount",
  props: {
    floor: {
      type: Object,
    },
  },
  data() {
    return {
      info: {
        name: "限时折扣",
        type: "", // 楼层类型
        style: "", // 1-视频 2-资料
        contentOrigin: 2, // 1-默认 2-自定义
        order: "",
        count: 0, // 展示数量
        maxCount: 12, // 最大展示数量
        contentList: [], // 楼层内容列表
      },
      DIYContentList: [], // 自定义内容的列表
      options: [
        {
          label: "资料",
          value: 1,
        },
        {
          label: "视频",
          value: 2,
        },
      ],
    };
  },
  watch: {
    "$store.state.mDecoration.currentFloor": {
      handler(newValue) {
        this.info = JSON.parse(JSON.stringify(newValue));
      },
      immediate: true,
      deep: true,
    },
    floor: {
      handler() {
        // 清空之前的DIYContentList缓存
        this.DIYContentList = [];
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    shopId() {
      return this.$store.state.user.userInfo.shopId;
    },
  },
  mounted() {
    // 开启拖拽排序
    var el = document.getElementById("content-list");
    new Sortable(el, {
      animation: 150,
      filter: ".no-change",
      onUpdate: (evt) => {
        // 改变数组排序
        const temp = this.info.contentList[evt.oldIndex];
        this.info.contentList.splice(evt.oldIndex, 1);
        this.info.contentList.splice(evt.newIndex, 0, temp);
        const list = JSON.parse(
          JSON.stringify(this.$store.state.mDecoration.floorList)
        );
        list[this.floor.index] = this.info;
        this.$store.commit("mDecoration/setFloorList", list);
        // 重新按顺序渲染dom 确保视图和数据一致
        const arr = this.info.contentList.slice(0);
        this.info.contentList = [];
        this.$nextTick(() => {
          this.info.contentList = arr;
        });
      },
    });
  },

  methods: {
    // 更新数据到vuex中
    updateVuex() {
      const list = JSON.parse(
        JSON.stringify(this.$store.state.mDecoration.floorList)
      );
      // console.log("this.floor-------", this.floor);
      list[this.floor.index] = this.info;
      // console.log("this.info-------", this.info);
      this.$store.commit("mDecoration/setFloorList", list);
      this.$store.commit("mDecoration/setCurrentFloor", this.info);
    },
    // 修改资源类型
    changeHandler() {
      if (this.info.style === 1) {
        this.info.type = "资料";
      } else if (this.info.style === 2) {
        this.info.type = "视频";
      } else {
        this.info.type = "";
      }
      this.info.contentList = [];
      this.DIYContentList = [];
      // 更新数据到vuex中
      this.updateVuex();
    },
    // 显示自定义内容弹窗
    addDIYContent() {
      if (!this.info.style) {
        this.$message({
          message: `请先选择内容来源`,
          type: "warning",
        });
        return;
      }
      // 更新数据到vuex中
      this.$store.commit("mDecoration/setCurrentFloor", this.info);
      this.$store.commit("mDecoration/setDialogType", "diyContent");
    },
    // 删除已选择的自定义内容
    delSelectContent(index) {
      // 删除数据
      this.info.contentList.splice(index, 1);
      // 更新数据总量
      this.info.count = this.info.contentList.length;
      // 更新数据到vuex中
      this.updateVuex();
    },
  },
};
</script>

<style lang="scss" scoped>
.aside-box {
  .floor-name {
    margin-bottom: 40px;
  }
  .info-name {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 20px;

    span {
      margin-right: 4px;
      font-size: 15px;
      font-weight: 600;
      color: #fe4509;
    }
    p {
      font-size: 15px;
      font-weight: 500;
      color: #606266;
    }
    .name-tip {
      margin-left: 10px;
      color: #c4c8d0;
      font-size: 12px;
      line-height: 12px; /* 100% */
    }
  }
  .info-content {
    padding-left: 12px;
    ::v-deep .el-input--prefix .el-input__inner {
      padding-left: 60px !important;
    }
    .name-icon-box {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 50px;
      height: 40px;
    }
    .discount-name-icon {
      width: 50px;
      height: 12px;
    }
    .info-content-item {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-bottom: 24px;

      & > span {
        margin-right: 4px;
        font-size: 15px;
        font-weight: 600;
        color: #fe4509;
      }

      & > p {
        position: relative;
        width: 80px;
        font-size: 12px;
        color: #606266;
        & > span {
          position: absolute;
          top: 0;
          left: -10px;
          color: #fe4509;
          font-size: 15px;
          font-style: normal;
          font-weight: 600;
          line-height: 15px; /* 100% */
        }
      }
      & > div {
        width: 232px;
        .type-select {
          width: 100%;
        }
      }
    }
    .zdy-content {
      .content-list {
        .content-li {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 280px;
          height: 32px;
          padding: 0 15px;
          margin-bottom: 15px;
          background: #f5f5f5;
          border-radius: 5px;

          p {
            width: 250px;
            font-size: 12px;
            color: #606266;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .del-content-icon {
            width: 11px;
            height: 12px;
            background: url(../../../assets/images/pc-decoration/del-floor-icon.png)
              no-repeat;
            background-size: 100% 100%;
            cursor: pointer;

            &:hover {
              background: url(../../../assets/images/pc-decoration/del-floor-icon2.png)
                no-repeat;
              background-size: 100% 100%;
            }
          }
        }
      }
    }
    .add-content-li {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 310px;
      height: 32px;
      margin-bottom: 30px;
      background: #ffffff;
      border: 1px dashed #5a83ff;
      border-radius: 5px;
      cursor: pointer;

      span {
        font-size: 20px;
        font-weight: 500;
        transform: translate(-2px, -2px);
        color: #5a83ff;
      }

      p {
        font-size: 14px;
        color: #5a83ff;
      }
      div {
        font-size: 12px;
        color: #c4c8d0;
      }

      .edit-icon {
        width: 9px;
        height: 12px;
        margin-right: 5px;
      }
    }
  }
}
</style>
